export default function Machines_A_5 (number = 1) {
  return {
    name: '太阳能板',
    icon: '/static/img/machines/a5.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_5.js